import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('tooltip', {
    beforeMount(el, binding) {
      const tooltipText = binding.value;
      if (!tooltipText) return;

      el.classList.add('tooltip-directive-element');

      let tooltip = el.querySelector('.directive-tooltip');
      if (tooltip) {
        return;
      }

      tooltip = document.createElement('div');
      tooltip.className = 'directive-tooltip';
      tooltip.textContent = tooltipText;

      if (binding.arg && !isNaN(Number(binding.arg.toString()))) {
        tooltip.style.top = `${binding.arg}px`;
      }
      
      el.appendChild(tooltip);
    },
  })
});